// extracted by mini-css-extract-plugin
export var actionButton = "_yj-2";
export var card = "_yj-0";
export var disambiguationList = "_yj-3";
export var errorCard = "_yj-4";
export var row = "_yj-1";